import { render, staticRenderFns } from "./TrainingGroupStatsSide.vue?vue&type=template&id=230ed946&scoped=true&"
import script from "./TrainingGroupStatsSide.vue?vue&type=script&lang=js&"
export * from "./TrainingGroupStatsSide.vue?vue&type=script&lang=js&"
import style0 from "./TrainingGroupStatsSide.vue?vue&type=style&index=0&id=230ed946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ed946",
  null
  
)

export default component.exports